exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{margin:0;font-family:Helvetica Neue,Helvetica,Arial,sans-serif;background:#f5f7fa;color:#303133}*{box-sizing:border-box}#app{min-height:100vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/assets/js/app.css
// module id = HBPh
// module chunks = 0